import { Bonomove } from "./bonomove";
import { FiltroBusquedaCaja } from "./caja";
import { Cliente } from "./cliente";
import { Servicio } from "./servicio";

export class FiltroBusquedaDevoluciones {
  // activo: boolean;
  referencia: string | null;
  concepto: number | null;
  clienteId: number | null;
  fechaDesde: string | null;
  fechaHasta: string | null;
  tiendaId: number | null;
  orden: string;

  constructor(init?: Partial<FiltroBusquedaDevoluciones>) {
     Object.assign(this, init);
  }
}

export class Devolucion {
  id!: number;
  concepto!: string;
  tipo!: number | null;
  cliente!: Cliente | null;
  importe!: number;
  text!: string;
  tiendaId!: number;
  dia!: Date;
  formapago!: number;
  modificable!: boolean;
  fechaAlta!: Date;

  constructor(init?: Partial<Devolucion>) {
    Object.assign(this, init);
  }
}

export interface DevolucionProducto {
  id: number;
  devolucionId: number;
  productoId: number;
  eventProductoId?: number; // Agregado para identificar el producto específico del ticket
  cantidad: number;
}

export interface DevolucionServicio {
  id: number;
  devolucionId: number;
  eventServicioId: number;
  eventServicioDetalleId?: number; // Agregado para diferenciar múltiples instancias del mismo servicio
  pagadoConBonocliente?: boolean; // Indica si el servicio fue pagado originalmente con bonocliente
  devueltoComoDinero?: boolean; // Indica si se forzó la devolución como dinero
}

// devolucion para edicion
export interface DevolucionEdicion {
  id: number;
  concepto: string;
  tipo: number;
  cliente: Cliente;
  importe: number;
  text: string;
  tiendaId: number;
  dia: Date;
  formapago: number;
  productos: DevolucionProducto[];
  servicios: DevolucionServicio[];
  bonomoves: Bonomove[];
}

export class DevolucionesAccionCaja {
  devoluciones!: Devolucion[];
  efectivoSum: number;
  tarjetaSum: number;
  otrosSum: number;

  constructor(init?: Partial<DevolucionesAccionCaja>) {
    Object.assign(this, init);
  }
}

// ========== Interfaces para Items Disponibles ==========

export interface InfoDevolucion {
  devolucionId: number;
  fechaDevolucion: string; // ISO format
  cantidad?: number; // Solo para productos
}

export interface ServicioDisponible {
  eventServicioId: number;
  eventServicioDetalleId: number;
  nombre: string;
  precio: number;
  vendedorId?: number;
  vendedorNombre?: string;
  devuelto: boolean;
  devolucionInfo?: InfoDevolucion; // Null si no está devuelto
}

export interface ProductoDisponible {
  eventProductoId: number;
  nombre: string;
  precio: number;
  cantidadTotal: number;
  cantidadDevuelta: number;
  cantidadDisponible: number;
  devoluciones: InfoDevolucion[]; // Lista de devoluciones que afectan a este producto
}

export interface ItemsDisponiblesTicket {
  ticketId: number;
  servicios: ServicioDisponible[];
  productos: ProductoDisponible[];
  tieneItemsDisponibles: boolean; // Al menos un item disponible para devolver
}
